<template>
  <el-dialog v-el-drag-dialog :visible.sync="dialogVisible" title="打印工单" width="800px">
    <div id="printProductionCard">
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td rowspan="3">
            <div id="qrCode" align="center"/>
          </td>
          <td colspan="3" style="text-align: center; font-weight: 700; font-size: 14px">工单</td>
        </tr>
        <tr>
          <td colspan="2">派工单号：{{productInfo.billNo}}</td>
          <td>工单号：{{productInfo.productionOrderNo}}</td>
        </tr>
        <tr>
          <td colspan="2">物料名称：{{productInfo.materialName}}</td>
          <td>物料编号：{{productInfo.materialNo}}</td>
        </tr>
        <tr>
          <td style="width: 20%">工单类型：{{productInfo.prodOrderTypeName}}</td>
          <td colspan="2">规格：{{productInfo.specification}}</td>
          <td>工作中心：{{productInfo.workCenterName}}</td>
        </tr>
        <tr>
          <td colspan="2">工艺路线：{{productInfo.routingName}}</td>
          <td>工单数量：{{productInfo.quantity}}</td>
          <td>单位：{{productInfo.unitName}}</td>
        </tr>
        <tr>
          <td colspan="2">开工时间：{{productInfo.planStartTime}}</td>
          <td colspan="2">完工时间：{{productInfo.planFinishTime}}</td>
        </tr>
        <tr>
          <td colspan="2">销售单号：{{productInfo.salesOrderNo}}</td>
          <td colspan="2">ERP单号：{{productInfo.erpSalesOrderNo}}</td>
        </tr>
        <tr>
          <td colspan="2" style="width: 50%">合同号：{{productInfo.customerContractNo}}</td>
          <td colspan="2" style="width: 50%">项目名称：{{productInfo.projectName}}</td>
        </tr>
        <tr>
          <td colspan="4">客户名称：{{productInfo.customerName}}</td>
        </tr>
        <tr>
          <td colspan="4">最终客户：{{productInfo.finalCustomerName}}</td>
        </tr>
        <tr>
          <td colspan="4">订单备注：{{productInfo.salesOrderMaterialNote}}</td>
        </tr>
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        dialogVisible: false,
        productInfo: {},
      };
    },

    methods: {
      open(productInfo) {
        this.productInfo = productInfo;
        this.dialogVisible = true;
        const item = this.productInfo.billNo;
        this.$nextTick(() => {
          document.getElementById("qrCode").innerHTML = "";
          this.bindQRCode(item);
        });
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode"), {
          text: text,
          width: 140,
          height: 140,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printProductionCard").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>
<style lang="scss" scoped>
#printProductionCard {
  td {
    border: 1px solid #111;
    border-right: 0;
    border-bottom: 0;
    padding: 10px 6px;
    box-sizing: border-box;
    font-size: 10px;
    min-width: 140px;
    white-space: pre-wrap;
  }
  tr {
    width: 700px;
  }
  tr td:last-child {
    border-right: 1px solid #111;
  }
  tr:last-child td {
    border-bottom: 1px solid #111;
  }
  .el-checkbox {
    margin-right: 5px;
    top: 1px;
  }
}
@media print {
  table {
    td {
      word-break: break-all;
    }
  }
  
}
</style>
